import React from "react";
import { Button } from "reactstrap";
import { confirmDeleteMessage } from "../../utils/alertUtils";

import { SAVE, TIME_FORMAT } from "./NoteConstants";

/**
 * Returns a list of<table> rows <tr> from the notes.
 *
 * @param {Array} notes - Store Notes array containing objects with
 * information about each note.
 * @param {React.SetStateAction} editNotes - Setter function for the
 * Store notes field.
 * @param {React.SetStateAction} setName - Local name field state setter
 * function.
 * @param {React.SetStateAction} setLNote - Local note state setter
 * function.
 * @param {React.SetStateAction} setIndex - Local index state setter
 * function.
 * @param {React.SetStateAction} setButtonText - Local button text
 * state setter function.
 * @callback clearFields - Function to set local states to initial value
 */
const NoteListData = ({
	notes,
	editNotes,
	setLNote,
	setIndex,
	clearFields,
	setButtonText,
	disableButtons,
	saveNotes,
	toggle,
}) => {
	console.log(notes);
	// Handles the onClick for the Edit button
	const handleEdit = (description, index) => {
		setButtonText(SAVE);
		setLNote(description);
		setIndex(index);
		toggle();
	};

	// Handles the onClick for the Delete button
	const handleDelete = (index) => {
		let confirmDelete = "Cancel";
		confirmDeleteMessage("Yes, Delete it").then((res) => {
			confirmDelete = res;
			if (confirmDelete === "Yes, Delete it") {
				// Use immutable array manipulation
				const newNotes = [...notes]; // Create a copy of the notes array
				newNotes.splice(index, 1); // Remove the item from the copied array
				// Update state with the new array
				editNotes(newNotes);
				clearFields();
				saveNotes(); // Save the updated notes
			}
		});
	};
	const parseCustomDate = (s) => {
		if (!s || typeof s !== "string") return 0;

		const re =
			/^([A-Za-z]{3})\s+(\d{1,2}),\s+(\d{4})\s+at\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)$/i;

		const m = s.trim().match(re);
		if (!m) return 0;

		const [, monStr, dStr, yStr, hStr, minStr, secStr, ampm] = m;

		const monthMap = {
			jan: 0,
			feb: 1,
			mar: 2,
			apr: 3,
			may: 4,
			jun: 5,
			jul: 6,
			aug: 7,
			sep: 8,
			oct: 9,
			nov: 10,
			dec: 11,
		};

		const mon = monthMap[monStr.toLowerCase()];
		if (mon == null) return 0;

		const year = parseInt(yStr, 10);
		const day = parseInt(dStr, 10);

		let hour = parseInt(hStr, 10);
		const minute = parseInt(minStr, 10);
		const second = secStr ? parseInt(secStr, 10) : 0;

		// Convert to 24h
		const isPM = ampm.toLowerCase() === "pm";
		if (hour === 12 && !isPM) hour = 0; // 12am -> 00
		else if (hour !== 12 && isPM) hour += 12; // 1pm..11pm -> 13..23

		// Local time (matches how you likely created these strings)
		const dt = new Date(year, mon, day, hour, minute, second);
		return dt.getTime();
	};
	return [...notes]
		.sort((a, b) => parseCustomDate(b.createdOn) - parseCustomDate(a.createdOn))
		.map((obj, index) => (
			<tr key={`${obj.createdOn}_${index}`}>
				<th scope="row">{index + 1}</th>
				<td>{obj?.createdBy}</td>
				<td>{obj?.createdOn}</td>
				<td>{obj?.modifiedBy}</td>
				<td>{obj?.modifiedOn}</td>
				<td>{obj.description}</td>
				<td>
					<Button
						readOnly={disableButtons}
						color="primary"
						className="btn-sm"
						onClick={() => handleEdit(obj.description, index)}
					>
						Edit
					</Button>
					<Button
						readOnly={disableButtons}
						color="danger"
						className="btn-sm"
						onClick={() => handleDelete(index)}
					>
						X
					</Button>
				</td>
			</tr>
		));
};

export default NoteListData;
